export const DashboardPath = '/';
export const ReviewsPath = '/reviews';
export const PhotosPath = '/photos';
export const UsersPath = '/users';
export const DevicesPath = '/devices';
export const ComplaitnsPath = '/complaints';
export const CommentsPath = '/comments';
export const AreasPath = '/areas';
export const ReportsPath = '/reports';
export const CreateNewAreaPath = 'create-new-area';
